import { Container } from "@fideus-ui/core";
import { createFileRoute, getRouteApi } from "@tanstack/react-router";
import { TransactionsTab } from "../../../companies/transactions/TransactionsTab";

const companyRoute = getRouteApi("/firmen/$companyId");

export const Route = createFileRoute("/firmen/$companyId/transaktionen")({
  loader: ({ context: { queryClient, trpc }, params: { companyId } }) => {
    void queryClient.ensureQueryData(
      trpc.transactions.listBanksByCompanyId.queryOptions({ companyId })
    );
  },
  component: TransaktionenRoute,
});

function TransaktionenRoute() {
  const { companyId } = Route.useParams();
  const { jahr } = companyRoute.useSearch();

  return (
    <Container>
      <TransactionsTab companyId={companyId} selectedYear={jahr} />
    </Container>
  );
}
